module.exports = __webpack_public_path__ + "img/WelcomeEmail.b5e57212.png";